export default "__VITE_ASSET__DHS76ywF__"